import { render, staticRenderFns } from "./PlatformTypeSelector.vue?vue&type=template&id=142beb50&scoped=true"
import script from "./PlatformTypeSelector.vue?vue&type=script&lang=js"
export * from "./PlatformTypeSelector.vue?vue&type=script&lang=js"
import style0 from "./PlatformTypeSelector.vue?vue&type=style&index=0&id=142beb50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142beb50",
  null
  
)

export default component.exports